"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "InstallationTab", {
  enumerable: true,
  get: function get() {
    return _InstallationPanel.InstallationTab;
  }
});
Object.defineProperty(exports, "IntegrationTab", {
  enumerable: true,
  get: function get() {
    return _Tabs.default;
  }
});
Object.defineProperty(exports, "getInstallationPanel", {
  enumerable: true,
  get: function get() {
    return _InstallationPanel.getInstallationPanel;
  }
});

var _InstallationPanel = require("./InstallationPanel");

var _Tabs = _interopRequireDefault(require("./Tabs"));